export default "__VITE_ASSET__CUIRy9jl__"